import {
  Badge,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  Input,
  Select as SelectChakra,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { mobilityCategories } from "App/DMRC/issueCategory";
import { AppContext } from "AppProvider/AppContext";
import { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";
import { SELLER_CLIENT_URL } from "utils/env";

const CreateIssue = ({
  transaction_id,
  isOpen,
  onClose,
  customerDetails,
}: any) => {
  const { toastNotify } = useContext(AppContext);
  const [igmId, setIgmId] = useState("SS" + Date.now());
  const [issueStatus, setIssueStatus] = useState<any>(undefined);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
  const [subCategoryCode, setSubCategoryCode] = useState<string>("");
  const [category] = useState<any>(mobilityCategories);
  const [issueDescription, setIssueDescription] = useState<any>({});
  const [issueDetails, setIssueDetails] = useState<any>({});

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(e.target.value);
    setSelectedSubCategory("");
    setSubCategoryCode("");
  };

  const handleSubCategoryChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedCode = e.target.value;
    const selectedLabel =
      category[selectedCategory]?.find((sub: any) => sub?.code === selectedCode)
        ?.label || "";
    setSelectedSubCategory(selectedLabel);
    setSubCategoryCode(selectedCode);
    // igm();
  };

  useEffect(() => {
    // const second = setTimeout(() => {
    setIssueDetails({
      category: selectedCategory,
      subCategory: subCategoryCode,
      description: issueDescription,
    });
    // }, 2000);
  }, [selectedCategory, selectedSubCategory, issueDescription]);

  // const handleSubmit = () => {
  //   igm();
  // };

  // const igm = async () => {
  //   try {
  //     const igm = await createIGMFlow(
  //       "OPEN",
  //       transaction_id,
  //       igmId,
  //       customerDetails,
  //       issueDetails,
  //       `${SELLER_CLIENT_URL}/dmrc/igm/client/`
  //     );
  //     if (igm?.data?.message?.ack?.status === "ACK") {
  //       toastNotify({
  //         title: "Success",
  //         message: "Issue Opened",
  //         type: "success",
  //       });
  //       setTimeout(async () => {
  //         const response = await getProviderData(transaction_id, "issue");
  //         const { status, data }: any = response;
  //         if (status === "success") {
  //           setIssueStatus(data[data.length - 1]?.request?.message?.issue);
  //         }
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.log("error in igm", error);
  //   } finally {
  //     setIssueDetails({});
  //     setIssueDescription({ short: "", long: "" });
  //     setSelectedCategory("");
  //     setSelectedSubCategory("");
  //     setSubCategoryCode("");
  //   }
  // };

  const igm = async () => {
    try {
      const values = {
        context: {
          transaction_id: transaction_id,
          domain: "ONDC:TRV11",
        },
        message: {
          issue: {
            id: igmId,
            status: "OPEN",
            customer: {
              name: customerDetails?.name,
              email: customerDetails?.email || "",
              phone: customerDetails?.phone.substring(
                customerDetails?.phone?.length - 10,
                customerDetails?.phone?.length
              ),
            },
            category: issueDetails?.category,
            sub_category: issueDetails?.subCategory,
            issue_details: {
              short_desc: issueDetails?.description?.short,
              long_desc: issueDetails?.description?.long,
            },
          },
        },
      };
      // const response = await createIGMFlow(
      //   "OPEN",
      //   values,
      //   // "https://ondc-preprod.sequelstring.com/seller/dmrc/igm/client/issue"
      //   `${SELLER_CLIENT_URL}/dmrc/igm/client/issue`
      // );

      const uri = `${SELLER_CLIENT_URL}/dmrc/igm/client/issue`;
      const response: any = await appRequest("seller", "issueActions", {
        values,
        uri,
      });

      if (response?.data?.message?.ack?.status === "ACK") {
        toastNotify({
          title: "Success",
          message: "Issue Opened",
          type: "success",
        });
        setIssueDetails({});
        setIssueDescription({ short: "", long: "" });
        setSelectedCategory("");
        setSelectedSubCategory("");
        setSubCategoryCode("");
        onClose();
      } else {
        toastNotify({
          title: "Failed",
          message: "Something went wrong",
          type: "error",
        });
      }
    } catch (error) {
      console.log("error in igm", error);
      onClose();
    } finally {
      setIssueDetails({});
      setIssueDescription({ short: "", long: "" });
      setSelectedCategory("");
      setSelectedSubCategory("");
      setSubCategoryCode("");
    }
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={"sm"}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader color={"teal.400"} fontWeight={700}>
          Raise an issue
        </DrawerHeader>
        <DrawerBody>
          <Badge
            colorScheme={
              issueStatus?.issue_actions?.respondent_actions[0]
                ?.respondent_action === "PROCESSING"
                ? "yellow"
                : "grey"
            }
            fontSize="0.8em"
          >
            {
              issueStatus?.issue_actions?.respondent_actions[0]
                ?.respondent_action
            }
          </Badge>
          <Text ml={1} fontWeight={"500"}>
            {issueStatus?.issue_actions?.respondent_actions[0]?.short_desc}
          </Text>
          {issueStatus === undefined && (
            <Box mb={2} px={4} bg="white">
              <VStack spacing={6} align="stretch">
                <FormControl isRequired>
                  <FormLabel fontWeight="bold">Category</FormLabel>
                  <SelectChakra
                    placeholder="Select category"
                    onChange={handleCategoryChange}
                    bg="gray.50"
                    _hover={{ bg: "gray.100" }}
                  >
                    {Object.keys(category).map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </SelectChakra>
                </FormControl>

                <FormControl isRequired isDisabled={!selectedCategory}>
                  <FormLabel fontWeight="bold">Subcategory</FormLabel>
                  <SelectChakra
                    placeholder="Select subcategory"
                    value={selectedSubCategory ? subCategoryCode : ""}
                    onChange={handleSubCategoryChange}
                    bg={selectedCategory ? "gray.50" : "gray.200"}
                    _hover={{ bg: selectedCategory ? "gray.100" : "gray.200" }}
                  >
                    {selectedCategory &&
                      category[selectedCategory].map((sub: any) => (
                        <option key={sub.code} value={sub.code}>
                          {sub.label}
                        </option>
                      ))}
                  </SelectChakra>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontWeight="bold">Short Description</FormLabel>
                  <Input
                    placeholder="Provide a short description"
                    value={issueDescription.short}
                    onChange={(e) =>
                      setIssueDescription({
                        ...issueDescription,
                        short: e.target.value,
                      })
                    }
                    bg="gray.50"
                    _hover={{ bg: "gray.100" }}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel fontWeight="bold">Detailed Description</FormLabel>
                  <Textarea
                    placeholder="Provide a detailed description of the issue"
                    value={issueDescription.long}
                    onChange={(e) =>
                      setIssueDescription({
                        ...issueDescription,
                        long: e.target.value,
                      })
                    }
                    bg="gray.50"
                    _hover={{ bg: "gray.100" }}
                    resize="vertical"
                  />
                </FormControl>

                <Button
                  mt={6}
                  colorScheme="teal"
                  size="lg"
                  onClick={igm}
                  // isFullWidth
                  _hover={{ bg: "teal.600" }}
                >
                  Submit
                </Button>
              </VStack>
            </Box>
          )}
        </DrawerBody>

        <DrawerFooter>
          {/* <Button
            colorScheme="red"
            onClick={() => {
              igmClose();
              onClose();
            }}
          >
            Close Issue
          </Button> */}
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default CreateIssue;
